module.exports = __webpack_public_path__ + "img/Picture17.d797e66e.png";